// Enhanced ProductForm for Dawn — shows Adding… / Added ✓ and opens cart/drawer.
// Safe if this file already defines the custom element; we re-define only if not present.
(() => {
  const define = () => {
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.submitBtn = this.querySelector('button[name="add"]');
        this.errorBox = this.querySelector('.product-form__error');
        this.defaultBtnHTML = this.submitBtn ? this.submitBtn.innerHTML : '';
        if (!this.form) return;
        this.onSubmit = this.onSubmit.bind(this);
        this.form.addEventListener('submit', this.onSubmit);
      }

      setLoading(loading, text) {
        if (!this.submitBtn) return;
        this.submitBtn.toggleAttribute('disabled', loading);
        this.submitBtn.setAttribute('aria-busy', loading ? 'true' : 'false');
        if (typeof text === 'string') this.submitBtn.innerHTML = text;
      }

      showError(msg) {
        if (!this.errorBox) return;
        this.errorBox.textContent = msg || '';
        this.errorBox.style.display = msg ? 'block' : 'none';
      }

      openCartOrRedirect() {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
        document.dispatchEvent(new CustomEvent('cart:open'));
        setTimeout(() => { window.location.href = '/cart'; }, 150);
      }

      async onSubmit(e) {
        e.preventDefault();
        if (!this.form) return;

        this.showError('');
        this.setLoading(true, 'Adding…');

        try {
          const fd = new FormData(this.form);

          // Ensure a variant id is sent
          if (!fd.get('id')) {
            const idInput = this.form.querySelector('input[name="id"], select[name="id"]');
            if (!idInput || !idInput.value) {
              this.setLoading(false, this.defaultBtnHTML);
              this.showError('Please select a valid variant.');
              return;
            }
            fd.set('id', idInput.value);
          }

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: fd
          });
          const data = await res.json();

          if (!res.ok) {
            this.setLoading(false, this.defaultBtnHTML);
            this.showError(data?.description || 'Unable to add to cart.');
            return;
          }

          this.setLoading(false, 'Added ✓');
          document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
          this.openCartOrRedirect();
        } catch {
          this.setLoading(false, this.defaultBtnHTML);
          this.showError('Network error. Please try again.');
        }
      }
    }

    customElements.define('product-form', ProductForm);
  };

  // Avoid redefining if Dawn already defined it
  if (!customElements.get('product-form')) define();
})();
